module.exports = __webpack_public_path__ + "img/face10.e3a405bd.jpg";